import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import { bindActionCreators } from 'redux'
import { SubmissionError } from 'redux-form'

import { fetchArqueos } from '../actions/arqueos'
import { fetchMachines } from '../actions/machines'
import { fetchCustomers } from '../actions/customers'

import { renderInputField, renderSelectField } from '../utils/forms'

class ArqueosFilterForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loaded: false,
      loading: false
    }

    this.submit = this.submit.bind(this)
  }

  componentDidMount() {
    const { role, fetchMachines, fetchCustomers } = this.props

    fetchMachines()

    if (role === 'ADMIN') {
      fetchCustomers()
    }

    this.load(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.load(nextProps)
  }

  load(props) {
    const { role, machines, customers, arqueos } = props

    if (!arqueos.loading && arqueos.arqueosNeedRefresh) {
      this.submit(this.props.formValues)
    }

    if (!this.state.loaded && machines && (role !== 'ADMIN' || customers)) {
      this.setState({ loaded: true })
    }
  }

  renderYearOptions() {
    const currentYear = new Date().getFullYear();
    const years = [];

    for (let y = currentYear; y >= 2017; y--) {
      years.push(
        <option key={y} value={y}>{y}</option>
      );
    }

    return years;
  }

  submit(props) {
    this.setState({ loading: true });

    const { Year1, Year2, Machine, Customer, Country, ContractType } = props;

    const startDate = Year1 ? `${Year1}-01-01` : '';
    const endDate = Year2 ? `${Year2}-12-31` : '';

    return this.props.fetchArqueos(Machine, Customer, startDate, endDate, Country, ContractType)
      .then(response => {
        if (response.error) {
          throw new SubmissionError({
            _error: response.error.message,
            ...response.error.fields
          });
        }

        this.setState({ loading: false });
        return response;
      })
      .catch(error => {
        this.setState({ loading: false });
        throw error;
      });
  }

  render() {
    const { loaded } = this.state
    const { error, submitting, handleSubmit, machines, customers, role } = this.props

    if (!loaded) {
      return (
        <div class="spinner"><img src="/images/logo.png" alt="Logo" /></div>
      )
    }

    return (
      <form onSubmit={handleSubmit(this.submit)} className="mb-3">
        {submitting ? (<div className="row"></div>) : (
          <div className="row">
            <div className="col">
              <Field
                name="Machine"
                component={renderSelectField}
                label="Máquina"
              >
                <option value="">Todas</option>
                {machines.map((machine) => (
                  <option value={machine._id} key={machine._id}>
                    {machine.Serial}
                  </option>
                ))}
              </Field>
            </div>
            <div className="col">
              {role === 'ADMIN' &&
                <Field
                  name="Customer"
                  component={renderSelectField}
                  label="Cliente"
                >
                  <option value="">Todos</option>
                  {customers &&
                    customers
                      .sort((a, b) => a.Fullname.localeCompare(b.Fullname))
                      .map((customer) => (
                        <option value={customer._id} key={customer._id}>
                          {customer.Fullname}
                        </option>
                      ))}
                </Field>
              }
            </div>
            <div className="col">
              {role === 'ADMIN' &&
                <Field name="ContractType"
                  component={renderSelectField}
                  label="Contrato">
                  <option value="">Todos</option>
                  <option value="REVENUE SHARE">REVENUE SHARE</option>
                  <option value="SPACE RENTAL">SPACE RENTAL</option>
                  <option value="SALE">VENTA</option>
                  <option value="RENTAL">ALQUILER</option>
                </Field>
              }
            </div>
            <div className="col">
              {role === 'ADMIN' &&
                <Field name="Country"
                  component={renderSelectField}
                  label="País">
                  <option value="">Todos</option>
                  <option value="España">
                    España
                  </option>
                  <option value="Italia">
                    Italia
                  </option>
                </Field>
              }
            </div>
            <div className="col">
              <Field name="Year1"
                component={renderSelectField}
                label="Año 1">
                <option value="">Seleccionar</option>
                {this.renderYearOptions()}
              </Field>
            </div>
            <div className="col">
              <Field name="Year2"
                component={renderSelectField}
                label="Año 2">
                <option value="">Seleccionar</option>
                {this.renderYearOptions()}
              </Field>
            </div>
          </div>
        )}
        <div className="form-row">
          {error && <div className="alert alert-danger">{error}</div>}
        </div>
        <div className="form-row">
          {submitting ? (<div class="loading-wheel"></div>) : (
            <button className="btn bg-vw-dark text-white mr-1 button-center"
              type="submit"
              disabled={submitting}>
              <i className="fas fa-sync mr-1"></i>
              Aplicar filtros
            </button>
          )}
        </div>
      </form>
    )
  }
}

ArqueosFilterForm = reduxForm({
  form: 'ArqueosFilterForm',
})(ArqueosFilterForm)

const selector = formValueSelector('ArqueosFilterForm')

const mapStateToProps = state => ({
  machines: state.machines.machines,
  customers: state.customers.customers,
  arqueos: state.arqueos,
  role: state.auth.role,
  initialValues: {
    Machine: '',
    Customer: '',
    Country: '',
    ContractType: '',
    Year1: new Date().getFullYear().toString(),
    Year2: new Date().getFullYear().toString()
  },
  formValues: {
    Machine: selector(state, 'Machine'),
    Customer: selector(state, 'Customer'),
    Country: selector(state, 'Country'),
    ContractType: selector(state, 'ContractType'),
    Year1: selector(state, 'Year1'),
    Year2: selector(state, 'Year2'),
  }
})

const mapDispatchToProps = dispatch => ({
  fetchArqueos: bindActionCreators(fetchArqueos, dispatch),
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
  fetchCustomers: bindActionCreators(fetchCustomers, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(ArqueosFilterForm)
